var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"cta cta--primary--alt mini-basket",attrs:{"href":_vm.basketUrl}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'shopping-basket']}}),_vm._v(" "),_c('basket-item-quantity',{staticClass:"mini-basket__count",model:{value:(_vm.count),callback:function ($$v) {_vm.count=$$v},expression:"count"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }